import { render, staticRenderFns } from "./UgTableRow.vue?vue&type=template&id=50462d18&scoped=true"
import script from "./UgTableRow.vue?vue&type=script&lang=ts"
export * from "./UgTableRow.vue?vue&type=script&lang=ts"
import style0 from "./UgTableRow.vue?vue&type=style&index=0&id=50462d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50462d18",
  null
  
)

export default component.exports